import { priceFtToMeters, alert, clearAlerts, ftToMeters, cubicFtToMeters } from "../utils"
import { translations } from "../content/translations";
import { reportTemplate } from "../custom_forms"
import { jsPDF } from "jspdf";

//let lang = localStorage.getItem("user_language");
let lang = "en";

export const estimatorOnChange = () => {
    const columnHeight = document.querySelector("#columnHeight");
    const columdDiameter = document.querySelector("#diameter")
    const cardboardLenght =  document.querySelector("#cardboardLenght");
    const cardboardPrice = document.querySelector("#cardboardPrice");
    const diameter = document.querySelector("#diameter");
    const estimateButton = document.querySelector("#estimate_ft");
    const columnNumber = document.querySelector("#columns")
    const buyNowEstimator = document.querySelector("#buyNowCalc")
  
    buyNowEstimator && (buyNowEstimator.onclick = () => window.open("https://shop.fab-form.com/shop/fast-tube-25", '_blank',))
  
    estimateButton && (estimateButton.onclick = () => {
      const checkbox = document.querySelector("#sendEmailCheckbox");
  
      if (checkbox && checkbox.checked) {
        const esimatorModal = document.querySelector(".estimator_modal")
        esimatorModal && (esimatorModal.style.display = "block");
  
        const close = document.querySelector(".close-estimator-modal");
        const calculateOnly = document.querySelector("#calculateOnly");
        const calculateAndSend = document.querySelector("#calculateAndSend");
  
        close && (close.onclick = () => esimatorModal.style.display = "none");
        calculateOnly && (calculateOnly.onclick = () => {
          esimatorModal.style.display = "none";
          calculateFastTube();
        })
  
        calculateAndSend && (calculateAndSend.onclick = () => {
          const name = document.querySelector("#estimatorUserName");
          const email = document.querySelector("#estimatorUserEmail");
          if (name.value && email.value) {
            esimatorModal.style.display = "none";
            calculateFastTube(name.value, email.value);
          }
        })
      } else {
        calculateFastTube();
      }
    });
    
    const calculateFields = () => {
      const cardBoardData = data[columdDiameter.value].cd;
      let finalLength = undefined;
      let modulo = undefined;
      Object.keys(cardBoardData).forEach(length => {
        const fullLength = columnNumber.value * columnHeight.value
        if (+length % columnHeight.value === 0 && fullLength % +length === 0) {
          modulo = +length % columnHeight.value;
          finalLength = +length
          return
        } else if (modulo > (+length % columnHeight.value)) {
          modulo = +length % columnHeight.value;
          const difference = +length - columnHeight.value;
          if (finalLength === undefined || finalLength > difference) {
            finalLength = difference + +columnHeight.value;
            return
          }
          return
        } else {
          modulo = +length % columnHeight.value;
        }
      })
  
      cardboardLenght.value = finalLength;
      cardboardPrice.value = data[columdDiameter.value].cd[cardboardLenght.value]?.price;
    }
    columnNumber && (columnNumber.onchange = () => calculateFields());
    columnHeight && (columnHeight.onchange = () => calculateFields());
    cardboardLenght && (cardboardLenght.onchange = () => cardboardPrice.value = data[columdDiameter.value].cd[cardboardLenght.value]?.price);
    diameter && (diameter.onchange = (event) => cardboardPrice.value = data[event.target.value].cd[cardboardLenght.value]?.price);
}

export const data = {
    '8': {
        ft: { price: 1.79, cubic: 0.9 },
        cd: { 
            '4': { price: ''},
            '8': { price: 22},
            '12': { price: 35},
        }
    },
    '10': {
        ft: { price: 1.89, cubic: 1.1 },
        cd: { 
            '4': { price: ''},
            '8': { price: 28},
            '12': { price: 53},
        }
    },
    '12': {
        ft: { price: 2.41, cubic: 1.3 },
        cd: { 
            '4': { price: ''},
            '8': { price: 32},
            '12': { price: 48},
        }
    },
    '14': {
        ft: { price: 2.98, cubic: 1.5 },
        cd: { 
            '4': { price: ''},
            '8': { price: ''},
            '12': { price: 95},
        }
    },
    '16': {
        ft: { price: 3.41, cubic: 1.7 },
        cd: { 
            '4': { price: ''},
            '8': { price: ''},
            '12': { price: 105},
        }
    }
}

const removeErrorFields = () => {
    const errorFields = document.querySelectorAll(".error_field");
    errorFields && errorFields.forEach(field => {
        field.classList.remove("error_field")
    })
}

const sendPdf = async (name, email, report, installation, pouring, logo, youtube, facebook, instagram) => {
    const formData = new FormData();
    formData.append("formName", 'Fast-Tube Estimator Report');
    formData.append("Name", name);
    formData.append("Email", email);
    formData.append("Content", report);
    formData.append("Installation", installation);
    formData.append("Video", pouring);
    formData.append("Logo", logo);
    formData.append("YouTube", youtube);
    formData.append("Facebook", facebook);
    formData.append("Instagram", instagram);
    
    await fetch("/send-pdf", {
        method: "POST",
        body: formData
    })
}

const readBlob = async (blob)=> {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
} 

const getFile = async (url) => {
    const result = await fetch(url);
    const blob = await result.blob();
    const base64 = await readBlob(blob);
    return base64; 
}

export const calculateFastTube = async (name, email) => {
    const inputs = [columnHeight, diameter, labourCost, columns, cardboardLenght,
        cardboardPrice, shippingCost]
    const errorFileds = inputs.filter(input => !input.value)
    if (errorFileds.length) {
        errorFileds.forEach(field => field.classList.add("error_field"))
        alert(translations.noFilledIn[lang], 'warning');
    } else if (+cardboardLenght.value < +columnHeight.value) {
        removeErrorFields();
        columnHeight.classList.add("error_field")
        cardboardLenght.classList.add("error_field")
        alert(translations.overLength[lang], 'warning');
    } else {
        removeErrorFields()
        clearAlerts();
        const round = (value) => Math.round(value * 100) / 100
        
        const stLaborCostCalc = round(15/60 * labourCost.value);
        const stColumnQtyCalc = columns.value / Math.floor(ftToMeters(cardboardLenght.value) / columnHeight.value);
        const stShippingQtyCalc = cubicFtToMeters(Math.pow(diameter.value * 0.083 / 2, 2) * cardboardLenght.value * Math.PI * columns.value)
        const stColumnTotalCalc = round(cardboardPrice.value * stColumnQtyCalc);
        const stShippingTotalCalc = round(shippingCost.value * stShippingQtyCalc);
        const stLaborTotalCalc = round(stLaborCostCalc * columns.value);
        const stTotalCost = round(+stColumnTotalCalc + +stShippingTotalCalc + +stLaborTotalCalc);

        const ftColumnCostCalc = round(priceFtToMeters(data[diameter.value].ft.price));
        const ftLaborCostCalc = round(2/60 * labourCost.value);
        const ftColumnQtyCalc = columnHeight.value * columns.value;
        const ftShippingQtyCalc = cubicFtToMeters(data[diameter.value].ft.cubic);
        const ftColumnTotalCalc = round(ftColumnCostCalc * ftColumnQtyCalc);
        const ftShippingTotalCalc = round(shippingCost.value * ftShippingQtyCalc);
        const ftLaborTotalCalc = round(ftLaborCostCalc * columns.value);
        const ftTotalCost = round(+ftColumnTotalCalc + +ftShippingTotalCalc + +ftLaborTotalCalc)

        stColumnCost.innerText = cardboardPrice.value;
        stShippingCost.innerText = shippingCost.value;
        stLaborCost.innerText = stLaborCostCalc;
        stColumnQty.innerText = stColumnQtyCalc;
        stShippingQty.innerText = stShippingQtyCalc;
        stLaborQty.innerText = columns.value;
        stColumnTotal.innerText = stColumnTotalCalc;
        stShippingTotal.innerText = stShippingTotalCalc;
        stLaborTotal.innerText = stLaborTotalCalc;

        const stIcon = document.createElement("i")
        stIcon.classList.add("fa", "fa-times", "fa-lg", "red-color")
        const stSpan = document.createElement("span")
        stSpan.innerText = ` $${stTotalCost}`
        stTotal.textContent = ""
        stTotal.appendChild(stIcon)
        stTotal.appendChild(stSpan)
    
        ftColumnCost.innerText = ftColumnCostCalc;
        fttShippingCost.innerText = shippingCost.value
        ftLaborCost.innerText = ftLaborCostCalc;
        ftColumnQty.innerText = ftColumnQtyCalc;
        ftShippingQty.innerText = ftShippingQtyCalc;
        ftLaborQty.innerText = columns.value;
        ftColumnTotal.innerText = ftColumnTotalCalc;
        ftShippingTotal.innerText = ftShippingTotalCalc;
        ftLaborTotal.innerText = ftLaborTotalCalc;

        const ftIcon = document.createElement("i")
        ftIcon.classList.add("fa", "fa-check", "fa-lg", "green-color")
        const ftSpan = document.createElement("span")
        ftSpan.innerText = ` $${ftTotalCost}`
        ftTotal.textContent = ""
        ftTotal.appendChild(ftIcon)
        ftTotal.appendChild(ftSpan)

        const dataTable = {
            ftPrice: data[diameter.value].ft.price,
            columnHeight: columnHeight.value,
            diameter: diameter.value,
            labourCost: labourCost.value,
            columns: columns.value,
            cardboardLenght: cardboardLenght.value,
            cardboardPrice: cardboardPrice.value,
            shippingCost: shippingCost.value,
            stLaborCostCalc: stLaborCostCalc,
            stColumnQtyCalc: stColumnQtyCalc,
            stShippingQtyCalc: stShippingQtyCalc,
            stColumnTotalCalc: stColumnTotalCalc,
            stShippingTotalCalc: stShippingTotalCalc,
            stLaborTotalCalc: stLaborTotalCalc,
            stTotalCost: stTotalCost,
            ftColumnCostCalc: ftColumnCostCalc,
            ftLaborCostCalc: ftLaborCostCalc,
            ftColumnQtyCalc: ftColumnQtyCalc,
            ftShippingQtyCalc: ftShippingQtyCalc,
            ftColumnTotalCalc: ftColumnTotalCalc,
            ftShippingTotalCalc: ftShippingTotalCalc,
            ftLaborTotalCalc: ftLaborTotalCalc,
            ftTotalCost: ftTotalCost
        }

        if (name && email) {
            const pdf = new jsPDF('p', 'pt', 'a4');
            const installation = await getFile('/docs/fast-tube-installation.pdf');
            const fastTubePouring = await getFile('../videos/pour-concrete.mov');
            const fabFormLogo = await getFile('../images/fab-form-logo.png');
            const youtube = await getFile('../images/youtube.jpg');
            const facebook = await getFile('../images/facebook.jpg');
            const instagram = await getFile('../images/instagram.jpg');

            pdf.html(reportTemplate(dataTable), {
                callback: () => sendPdf(name, email, pdf.output('datauristring'), installation, fastTubePouring, fabFormLogo, youtube, facebook, instagram)
            })
        }
    }
}